import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

interface Props {
    value1: string,
    value2: string,
    name1: string,
    name2: string,
    id: string,
    index: number,
    error?: boolean,
    helper?:string,
	placeholder1?:string,
	placeholder2?:string,
    maxLength1?:number,
    minLength1?:number;
    maxLength2?:number,
    minLength2?:number;
    row?:boolean;
    change(name:string,index:number,value1:string,value2:string): void,
    addError?(name:string,flag:boolean): void,
}


const TwinInput:React.FC<Props> = (props)=> {
    let error = "";
	const changeInput = (index:number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if( index===1 ){
            props.change(props.id,props.index,event.target.value,props.value2);
        } else {
            props.change(props.id,props.index,props.value1,event.target.value);
        }
    };
    const validate = ()=>{
        error = "";
        if( (props.value1!=="" && props.value2==="") || (props.value2!=="" && props.value1==="") ){
            //error = "不要なら削除";
        }

        if( error !=="" ){
            if( props.addError ){
                props.addError(props.id+String(props.index),true);
            }
            return true;
        } else {
            if( props.addError ){
                props.addError(props.id+String(props.index),false);
            }
            return false;
        }
    }

    validate();

    let row = false;
    if( props.row ){
        row = true;
    }

	let maxLength1 = 0;
	let classCounter1 = 'formCounter';
	let rest1 = 0;
	let maxLength2 = 0;
	let classCounter2 = 'formCounter';
	let rest2 = 0;

	if( props.maxLength1 ){
		maxLength1 = props.maxLength1;
		rest1 = maxLength1;
		const v = props.value1 as string;
		if( v ){
			rest1 -=  v.length;
			if( rest1<0 ){
				classCounter1 += " formCounterMinus";
			}
		}
	}
	if( props.maxLength2 ){
		maxLength2 = props.maxLength2;
		rest2 = maxLength2;
		const v = props.value2 as string;
		if( v ){
			rest2 -=  v.length;
			if( rest2<0 ){
				classCounter2 += " formCounterMinus";
			}
		}
	}


    if( row ){
        return (
            <Grid container spacing={1} style={{marginBottom:'0.25em'}}>
                <Grid item xs={5} sm={3}>
                    <FormControl fullWidth={true} error={error!==""}>
                        <TextField
                            id={props.id}
                            value={props.value1}
                            onChange={changeInput(1)}
                            label={props.name1}
							placeholder={props.placeholder1}
                            variant="filled"
                        />
						{maxLength1>0 &&
						<div className={classCounter1}>{rest1}</div>
						}						
                        {error!=="" &&
                        <FormHelperText>※{error}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={7} sm={9}>
                    <FormControl fullWidth={true} error={error!==""}>
                        <TextField
                            id={props.id}
                            value={props.value2}
                            onChange={changeInput(2)}
                            label={props.name2}
							placeholder={props.placeholder2}
                            variant="filled"
                        />
						{maxLength2>0 &&
						<div className={classCounter2}>{rest2}</div>
						}
                    </FormControl>
                </Grid>
            </Grid>
        );    
    } else {
        return (
            <Grid container spacing={0} style={{marginBottom:"1em"}}>
                <Grid item xs={12}>
                    <FormControl fullWidth={true} error={error!==""}>
                        <TextField
                            id={props.id}
                            value={props.value1}
                            onChange={changeInput(1)}
							label={props.name1}
                            placeholder={props.placeholder1}
                            variant="filled"
                        />
						{maxLength1>0 &&
						<div className={classCounter1}>{rest1}</div>
						}						
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth={true} error={error!==""}>
                        <TextField
                            id={props.id}
                            value={props.value2}
                            onChange={changeInput(2)}
							label={props.name2}
                            placeholder={props.placeholder2}
                            variant="filled"
                        />
						{maxLength2>0 &&
						<div className={classCounter2}>{rest2}</div>
						}						
                        {error!=="" &&
                        <FormHelperText>※{error}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
            </Grid>
        );    
    }
}

export default TwinInput;
